import { IndustryContact } from 'types/Industry.types'

import { Input } from 'components/Input'
import { InputPhone } from 'components/InputPhone'
import { IconButton } from '@material-ui/core'
import { Icon } from 'components/Icon'
import { useTranslation } from 'react-i18next'

import { ERRORS_INITIAL_STATE } from 'constants/industry.constants'

import * as S from './styled'

export type ContactFormProps = {
  errors: typeof ERRORS_INITIAL_STATE
  index: number
  payload: IndustryContact
  removeButton: boolean
  onFill: (_key, _val, _index) => void
  onRemove: (_index) => void
  documentType?: string
}

export function ContactForm({
  index,
  errors,
  payload,
  removeButton,
  onFill,
  onRemove,
  documentType
}: ContactFormProps) {
  function err(name: string) {
    const { contacts } = errors
    return contacts
      ? contacts[index][name]
      : errors[`contacts[${index}].${name}`]
  }
  const { t } = useTranslation()

  return (
    <S.Wrapper>
      <S.Remove>
        {removeButton && (
          <S.Removed onClick={onRemove}>
            <p>{t('common:delete')}</p>
            <IconButton
              style={{ backgroundColor: '#ffffff' }}
              aria-label="delete picture"
              component="span"
            >
              <Icon icon="delete-image" height={16} width={16} fill="#de4f4f" />
            </IconButton>
          </S.Removed>
        )}
      </S.Remove>
      <S.GridFields container spacing={2}>
        <S.GridInput item sm={12} md={4}>
          <Input
            fullWidth
            label={t('profile:contactName')}
            value={payload.name}
            error={Boolean(err('name'))}
            helperText={err('name')}
            onInput={value => onFill('name', value, index)}
          />
        </S.GridInput>
        <S.GridInput item sm={12} md={4}>
          {documentType === 'internacional' ? (
            <Input
              fullWidth
              label={t('profile:contactPhone')}
              value={payload.phone}
              error={Boolean(err('phone'))}
              helperText={err('phone')}
              onInput={value => onFill('phone', value, index)}
            />
          ) : (
            <InputPhone
              fullWidth
              label={t('profile:contactPhone')}
              value={payload.phone}
              error={Boolean(err('phone'))}
              helperText={err('phone')}
              onInput={value => onFill('phone', value, index)}
            />
          )}
        </S.GridInput>
        <S.GridInput item sm={12} md={4}>
          <Input
            fullWidth
            label={t('profile:contactEmail')}
            value={payload.email}
            error={Boolean(err('email'))}
            helperText={err('email')}
            onInput={value => onFill('email', value, index)}
          />
        </S.GridInput>
      </S.GridFields>
    </S.Wrapper>
  )
}
